import { useState } from 'react';

import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import useSWR from 'swr';

import { DataGrid } from '~components';
import { getService } from '~services/serviceFactory';

import Event from '../../interfaces/event';
import LogsService from '../../services/logsService';

const service = getService(LogsService);

interface Props {
	deviceId: string;
}

const LogsDataGrid = ({ deviceId }: Props) => {
	const [pagination, setPagination] = useState<GridPaginationModel>({
		page: 1,
		pageSize: 10,
	});

	const columns: GridColDef<Event>[] = [
		{
			field: 'serverTimestamp',
			headerName: 'timestampServer',
			flex: 1,
			type: 'date',
			valueFormatter: (value: Date) => value?.toLocaleString(),
		},
		{
			field: 'action',
			headerName: 'action',
			flex: 1,
		},
		{
			field: 'modifiedBy',
			headerName: 'modifiedBy',
			flex: 1,
		},
	];

	const { data, error, isLoading, isValidating } = useSWR(
		service.getLogsCacheKey(deviceId),
		() => service.getLogs(deviceId, pagination.page, pagination.pageSize),
		{
			onSuccess: (data) => data?.total && setTotalCount(data.total),
		}
	);
	const [totalCount, setTotalCount] = useState<number>(data?.total || 0);

	const handlePaginationChange = (value: GridPaginationModel) => {
		setPagination({ page: value.page + 1, pageSize: value.pageSize });
	};

	return (
		<DataGrid
			persistenceKey='events'
			error={error != null}
			disableRowSelectionOnClick
			loading={isLoading || isValidating}
			columns={columns}
			rows={data?.results ?? []}
			rowCount={totalCount}
			paginationMode='server'
			paginationModel={pagination}
			onPaginationModelChange={handlePaginationChange}
			sx={{ flexGrow: 1, width: 1, height: '100%', overflowX: 'auto' }}
		/>
	);
};

export default LogsDataGrid;
